import fetchClient from "api/client";
import VARIABLE_ENDPOINT from "./variableEndpoint";

/**
 * @description GET api/custom-vars/:id
 * @param {Object} context - https://tanstack.com/query/v4/docs/react/guides/query-functions#queryfunctioncontext
 * @param {["campaign-dropdown-list", { id: string }]} context.queryKey
 *
 * @return {Promise<Array<Variable>|Error>}
 * */
export default function getVariable({ queryKey: [, { id }] }) {
  return fetchClient.get(`${VARIABLE_ENDPOINT}/${id}`);
}

/**
 * @typedef {Object} Variable
 * @property {string} name
 * @property {"text" | "image"} type
 * */
